import { Phonenumber } from 'data/firestore/phonenumber/types';
import { CellWrapper } from '../../columns/styled';

interface Props {
    value?: string;
}

const pipelineMap: Record<Phonenumber['voicePipelineServer']['id'], string> = {
    elevenlabs: 'ElevenLabs',
    voxityV1: 'Voxity V1',
    workflow: 'Workflow',
};

const PhonePipelineColumn = ({ value }: Props) => {
    const pipeline = pipelineMap[value as Phonenumber['voicePipelineServer']['id']] ?? pipelineMap.voxityV1;
    return <CellWrapper>{pipeline}</CellWrapper>;
};

export default PhonePipelineColumn;
